import React from "react";
import { Recycle, Trash2, Home, ArrowRight } from "lucide-react";
import { MAIN_APP_URL } from "../../lib/config";

const PILLARS = [
  {
    id: "reuse",
    icon: Recycle,
    title: "Reuse",
    body: "Got something worth saving? List it free and keep it out of landfill. Someone nearby will want it.",
    cta: "List an item",
  },
  {
    id: "remove",
    icon: Trash2,
    title: "Remove",
    body: "Need something collected? Snap a photo, get quotes from registered waste carriers. Fast.",
    cta: "Post a job",
  },
  {
    id: "clear",
    icon: Home,
    title: "Clear",
    body: "Full house, garden or office clearance? Our carriers handle the lot. One job, sorted.",
    cta: "Get a clearance quote",
  },
];

export default function ThreePillars() {
  return (
    <section
      id="what-we-do"
      className="py-20 md:py-28 bg-cream-50"
      data-testid="pillars-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
            What we do
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold text-moss-950 leading-[1.05] text-balance">
            Three ways Binshare works for you.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            const isMiddle = i === 1;
            return (
              <div
                key={p.id}
                className={`group flex flex-col rounded-3xl p-8 lg:p-10 transition-transform duration-300 hover:-translate-y-1 ${
                  isMiddle
                    ? "bg-moss-950 text-cream-50 border border-moss-800"
                    : "bg-white text-moss-900 border border-moss-100"
                }`}
                data-testid={`pillar-card-${p.id}`}
              >
                <div
                  className={`w-14 h-14 rounded-2xl flex items-center justify-center ${
                    isMiddle ? "bg-sage-500 text-moss-950" : "bg-sage-100 text-sage-800"
                  }`}
                >
                  <Icon className="w-7 h-7" strokeWidth={2.25} />
                </div>

                <h3 className="font-display mt-6 text-3xl font-extrabold leading-tight">
                  {p.title}
                </h3>
                <p
                  className={`mt-3 text-base leading-relaxed flex-1 ${
                    isMiddle ? "text-cream-100/85" : "text-moss-700"
                  }`}
                >
                  {p.body}
                </p>

                <a
                  href={MAIN_APP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`mt-8 inline-flex items-center justify-between px-5 py-3 rounded-full text-sm font-semibold transition-all ${
                    isMiddle
                      ? "bg-cream-50 text-moss-950 hover:bg-cream-100"
                      : "bg-moss-900 text-cream-50 hover:bg-moss-950"
                  }`}
                  data-testid={`pillar-cta-${p.id}`}
                >
                  {p.cta}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
